// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Copyright (C) 2024 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

.exds-global-header {
  background-color: #062646;
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exds-global-header img {
  height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd","sourcesContent":["/*!\n * Copyright (C) 2024 JPMorgan Chase & Company\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, is not permitted.\n */\n\n.exds-global-header {\n  background-color: #062646;\n  padding: 0.75rem 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.exds-global-header img {\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
